import cloneDeep from 'lodash/cloneDeep';
import type { AdBlockerState, BlockerModel, BlockerState, BlockerType } from '../../types';
import { generateId } from '../../../../utils/generateId';

export class AdBlockerModel implements BlockerModel {
  public readonly underTile = false;

  public readonly id = generateId('ad');

  public readonly destructible = false;

  private readonly state: AdBlockerState;

  constructor(state: AdBlockerState) {
    this.state = cloneDeep(state);
  }

  public getType(): BlockerType {
    return this.state.type;
  }

  public exportState(): BlockerState {
    return this.state;
  }
}
